import { ComplexValue } from 'ui';
import { AttributeMappingType } from './constants';
import { LayoutAttributes } from './types';

export const mapLayoutAttributesToOptions = (layoutAttributes: { [key: string]: string | boolean | number },
  allOptions: ComplexValue<any>[],
  mapping: AttributeMappingType) => {
  return allOptions
    .filter(item => {
      switch (item.value) {
        case LayoutAttributes.fieldLabels:
          return !!mapping.hideHeader && !layoutAttributes[mapping.hideHeader];
        case LayoutAttributes.quantities:
          return !!mapping.hideAggrColumns && !layoutAttributes[mapping.hideAggrColumns];
        case LayoutAttributes.groups:
          return !!mapping.compactView && layoutAttributes[mapping.compactView];
        case LayoutAttributes.wideLayout:
          return !!mapping.wideLayout && layoutAttributes[mapping.wideLayout];
        case LayoutAttributes.totals:
          return !!mapping.hideTotals && !layoutAttributes[mapping.hideTotals];
        case LayoutAttributes.suppressRepeatingRows:
          return !!mapping.suppressRepeatingRows && layoutAttributes[mapping.suppressRepeatingRows];
        case LayoutAttributes.xAxisLabelsEnabled:
          return !!mapping.xAxisLabelsEnabled &&
            (layoutAttributes[mapping.xAxisLabelsEnabled] || layoutAttributes[mapping.xAxisLabelsEnabled] === undefined);
        case LayoutAttributes.yAxisLabelsEnabled:
          return !!mapping.yAxisLabelsEnabled &&
            (layoutAttributes[mapping.yAxisLabelsEnabled] || layoutAttributes[mapping.yAxisLabelsEnabled] === undefined);
        case LayoutAttributes.showValue:
          return !!mapping.showValue &&
            (layoutAttributes[mapping.showValue] || layoutAttributes[mapping.showValue] === undefined);
        case LayoutAttributes.showPercent:
          return !!mapping.showPercent &&
            (layoutAttributes[mapping.showPercent] || layoutAttributes[mapping.showPercent] === undefined);
        case LayoutAttributes.hideDatalabelsOnDashboards:
          return !!mapping.hideDatalabelsOnDashboards &&
            (layoutAttributes[mapping.hideDatalabelsOnDashboards] || layoutAttributes[mapping.hideDatalabelsOnDashboards] === undefined);
        case LayoutAttributes.stacked:
          return !!mapping.stacked && layoutAttributes[mapping.stacked];
        case LayoutAttributes.percent:
          return !!mapping.percent && layoutAttributes[mapping.percent];
        case LayoutAttributes.donutView:
          return !!mapping.donutView && layoutAttributes[mapping.donutView];
        case LayoutAttributes.semiCircleView:
          return !!mapping.semiCircleView && layoutAttributes[mapping.semiCircleView];
        case LayoutAttributes.lossPotential:
          return !!mapping.lossPotential && layoutAttributes[mapping.lossPotential] ||
            layoutAttributes[mapping.lossPotential] === undefined;
        case LayoutAttributes.residualLossPotential:
          return !!mapping.residualLossPotential && layoutAttributes[mapping.residualLossPotential];
        case LayoutAttributes.showCaseNumbers:
          return !!mapping.showCaseNumbers && layoutAttributes[mapping.showCaseNumbers];
        default:
          return false;
      }
    });
};
